export {
    SuiCollapseModule,
    SuiCollapse
} from "./index";
